import { matchPath, Outlet } from 'react-router';

import { ROUTING_PATHS } from 'const';
import { BreadcrumbRouteObject, isValidBulkDataType } from 'types';
import { BulkActionsPage } from './BulkActionsPage';
import { BULK_ACTION_CONFIGS } from './bulkActionConfig';

const { bulkActions } = ROUTING_PATHS;
export const BULK_ACTIONS_ROUTES: BreadcrumbRouteObject[] = [
  {
    path: bulkActions.path,
    element: <Outlet />,
    children: [
      {
        breadcrumb: {
          text: (location) => {
            const match = matchPath(bulkActions.path + '/:bulkDataType', location.pathname);

            if (!match?.params.bulkDataType || !isValidBulkDataType(match.params.bulkDataType)) {
              return 'Bulk actions';
            }

            const title = BULK_ACTION_CONFIGS[match.params.bulkDataType].title;
            return title ? `Bulk actions - ${title}` : 'Bulk actions';
          },
          icon: 'upload',
        },
        path: ':bulkDataType',
        element: <BulkActionsPage />,
      },
    ],
  },
];
